<template>
  <v-card outlined style="margin-bottom: 24px;">
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class=" text-uppercase align-self-center">Báo cáo hiệu suất công việc</h5>
    </div>

    <v-card-text class="d-flex justify-space-between pb-6 px-6 pt-0">
      <div>
        <div class="text-number pb-3 admin--text">
          {{ statusCount.countAll }}
        </div>
        <div>Khách hàng</div>
      </div>
      <div>
        <div class="text-number pb-3 light-blue--text">
          {{ statusCount.countNoContact }}
        </div>
        <div>Khách hàng chưa chăm sóc</div>
      </div>
      <div>
        <div class="text-number pb-3 orange--text">
          {{ statusCount.countAppointmentSet }}
        </div>
        <div>Khách hàng đã đặt lịch hẹn</div>
      </div>
      <div>
        <div class="text-number pb-3 warning--text">
          {{ statusCount.countProductVerified }}
        </div>
        <div>Khách hàng đã gặp trực tiếp</div>
      </div>
      <div>
        <div class="text-number pb-3 success--text">
          {{ statusCount.countSucceed }}
        </div>
        <div>Khách hàng đã đăng ký tuyển sinh</div>
      </div>
      <div>
        <div class="text-number pb-3 error--text">
          {{ statusCount.countFailed }}
        </div>
        <div>Khách hàng thất bại</div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    statusCount: Object
  },

  data() {
    return {
      products: []
    }
  },
  methods: {}
}
</script>

<style scoped>
.text-number {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-size: 28px;
  line-height: 33px;
  text-align: center;
}
</style>
